import type { clientAmount } from './types'
import clientAmountData from '../../data/clientAmountData.json'

export class clientAmountService {
  async myAmountClient(clientId: number ): Promise<clientAmount> {
    const item = clientAmountData.data.find(
      (clientAmount: { clientId: number }) => clientAmount.clientId === clientId,
    )
    if (!item) {
      throw new Error(`Client amount not found for clientId: ${clientId}`);
    }
    return item;
  }
}
